<template>
  <div class="app-header">
    <div class="banner">
      <el-carousel :interval="5000" height="320">
        <el-carousel-item v-for="(item, index) in swipeList" :key="index">
          <img class="banner-item" :src="item" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="box-menu">
      <el-row class="app-page-wrapper">
        <el-col :span="3" v-for="(item, index) in navList" :key="index">
          <div @click="activeTab(index)">
            <p class="tab" :class="index === activeName ? 'active' : ''">
              {{ item.title }}
            </p>
          </div>
        </el-col>
      </el-row>
    </div>    
  </div>
</template>
<script>
export default {
  data() {
    return {
      navList: [
        {
          id: 0,
          title: "网站首页",
          path: '/home'
        },
        {
          id: 1,
          title: "时政要闻",
          path: "/know/news",
        },
        {
          id: 2,
          title: "综合资讯",
          path: "/know/consult",
        },
        {
          id: 3,
          title: "部门资讯",
          path: "/unit/consult",
        },
        {
          id: 4,
          title: "文件资料",
          path: "/know/data",
        },
        {
          id: 5,
          title: "网上工会平台",
          jumpUrl: "http://admin.lhzgh.gov.cn",
        },
        {
          id: 6,
          title: "职工服务平台",
          path: '/staff/service'
        },
        {
          id: 7,
          title: "OA工作平台",
          jumpUrl: "https://lhghoa.ueware.com/",
        },
      ],
      swipeList: [
        require("@/assets/home/banner_00.png"),
        require("@/assets/home/banner_01.png"),
        require("@/assets/home/banner_02.png"),
        require("@/assets/home/banner_03.png"),
        require("@/assets/home/banner_04.png")
      ],
      swiperWidth: window.innerWidth
    };
  },
  computed: {
    swiperHeight() {
      return (this.swiperWidth / 1920) * 450 + "px";
    },
    activeName() {
      const { path, name, params } = this.$route
      let result = { id: '' }
      if (name === 'newsDetails') {
        const activePath = params.type === 'unit' ? 'unit/consult' : `/know/${params.type}`
        result = this.navList.find(item => item.path && item.path === activePath) || { id: '' }
      } else {
        result = this.navList.find(item => item.path && item.path === path) || { id: '' }
      }
      return result.id  
    }
  },
  methods: {
    //自定义tab点击事件
    activeTab(index) {
      const item = this.navList[index];
      if (!item.jumpUrl) {
        this.$router.push(item.path)
      } else {
        window.open(item.jumpUrl);
      }
    },    
  }
}
</script>
<style lang="less" scoped>
  .banner {
    width: 100%;
    .el-carousel__item {
      height: 100%;
    }
    ::v-deep .el-carousel__arrow {
      width: 60px;
      height: 60px;
      font-size: 28px;
    }
    .banner-item {
      width: 100%;
    }
  }
  .box-menu {
    width: 100%;
    height: 50px;
    background: #c03429;
    .app-page-wrapper {
      margin: 0 auto;
      box-sizing: border-box;
    }
    // display: flex;
    // align-items: center;
    // justify-content: space-around;
    .tab {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      font-weight: 500;
      line-height: 33px;
      color: #ffffff;
      cursor: pointer;
      &:hover {
        background: rgba(0, 0, 0, 0.23) !important;
      }
    }
    .active {
      background: rgba(0, 0, 0, 0.23) !important;
      font-weight: bold !important;
    }
  }
</style>